import { BaseResponseBuilder } from './BaseResponseBuilder';
import { IBaseQueryBuilder } from './IBaseQueryBuilder';
import { IBaseArgument } from './IBaseArgument';
import { generateVariablesObject, generateVariableDefinitions, generateVariableParams } from './QueryVariablesHelper';

export abstract class BaseQueryBuilder implements IBaseQueryBuilder {
    private queryName: string = '';
    private responseBuilder: BaseResponseBuilder;
    protected args: IBaseArgument[] = [];

    constructor(queryName: string, responseBuilder: BaseResponseBuilder) {
        this.queryName = queryName;
        this.responseBuilder = responseBuilder;
    }

    protected addVariable = (name: string, graphQLType: string, isNonNullable: boolean, value: any): IBaseArgument => {
        return { name, graphQLType, isNonNullable, value };
    }

    public buildQuery = (): string => {
        const args = this.responseBuilder.getArguments(this.args);
        const fragmentHashes = this.responseBuilder.getFragmentsHashIds([]);
        this.responseBuilder.getFragmentDefinitions(fragmentHashes);
        const fragments = Object.keys(fragmentHashes).map((k) => `${fragmentHashes[k]}`).join('\n');
        const queryParams = generateVariableParams(this.args);
        return args.length ? `query ${this.queryName} (${generateVariableDefinitions(args)}) { ${this.queryName} ${queryParams ? `(${queryParams})` : ''} ${this.responseBuilder.build(fragmentHashes)} } ${fragments}` :
            `query ${this.queryName} { ${this.queryName} ${this.responseBuilder.build(fragmentHashes)} } ${fragments}`;
    }

    public buildVariables = (): { [key: string]: any } => {
        const args = this.responseBuilder.getArguments(this.args);
        return generateVariablesObject(args);
    };
}
